import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';

function api() {
    return axios.create({
        baseURL: getApiBaseUrl(),
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
}

export async function getCurrentShift(schoolId, organizationId, kkmDeviceId) {
    const res = await api().get('/cashier/current-shift', {
        params: { schoolId, organizationId, kkmDeviceId }
    });
    return res.data;
}

export async function openShift(body) {
    return api().post('/cashier/shifts/open', body);
}

export async function closeShift(id, schoolId, actualClosingCash) {
    return api().post(`/cashier/shifts/${id}/close`, { actualClosingCash }, { params: { schoolId } });
}

export async function depositCash(id, schoolId, amount, reason) {
    return api().post(`/cashier/shifts/${id}/deposit`, { amount, reason }, { params: { schoolId } });
}

export async function withdrawalCash(id, schoolId, amount, reason) {
    return api().post(`/cashier/shifts/${id}/withdrawal`, { amount, reason }, { params: { schoolId } });
}

export async function listShifts(schoolId, organizationId, from, to) {
    return api().get('/cashier/shifts', { params: { schoolId, organizationId, from, to } });
}

export async function getClosePreview(shiftId, schoolId) {
    return api().get(`/cashier/shifts/${shiftId}/close-preview`, { params: { schoolId } });
}

export async function downloadZReportPdf(shiftId, schoolId) {
    const res = await api().get(`/cashier/shifts/${shiftId}/z-report/pdf`, {
        params: { schoolId },
        responseType: 'blob'
    });
    return res;
}
